
export default {
  data: function data() {
    return {
      winWidth: 0,
      winHeight: 0,
      isDev: process.env.NODE_ENV !== 'production',
      xielunyanStatus: false
    };
  },

  components: {},
  props: {
    visibilityHeight: {
      type: Number,
      default: 100
    },
    right: {
      type: Number,
      default: 48
    },
    bottom: {
      type: Number,
      default: 48
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('resize', this.initBox);
    this.robserver = new ResizeObserver(function (entries) {
      _this.initBox();
    });
    this.robserver.observe(this.$refs['xielunyan']);
    this.xielunyanStatus = document.querySelector('body').className.indexOf('xielunyan') > -1;
  },
  destroyed: function destroyed() {
    this.robserver = null;
    window.removeEventListener('resize', this.initBox);
  },

  methods: {
    mousedown: function mousedown(e) {
      var xielunyan = this.$refs['xielunyan'];
      var disX = e.offsetX;
      var disY = e.offsetY;
      var that = this;
      document.onmousemove = function (e) {
        var maxWidth = that.winWidth - xielunyan.clientWidth;
        var maxHeight = that.winHeight - xielunyan.clientHeight;
        var x = maxWidth;
        var y = maxHeight;
        if (e.clientY - disY > 0 && e.clientY - disY < maxHeight) {
          y = e.clientY - disY + 'px';
        } else if (e.clientY - disY < 0) {
          y = 0 + 'px';
        } else {
          y = maxHeight + 'px';
        }
        if (e.clientX - disX > 0 && e.clientX - disX < maxWidth) {
          x = maxWidth - (e.clientX - disX) + 'px';
        } else if (e.clientX - disX < 0) {
          x = maxWidth + 'px';
        } else {
          x = 10 + 'px';
        }
        xielunyan.style.top = y;
        xielunyan.style.right = x;
      };
      document.onmouseup = function (e) {
        document.onmousemove = document.mousedown = null;
      };
    },
    handleXieLunYan: function handleXieLunYan(event) {
      var body = document.querySelector('body');
      if (body.className.indexOf('xielunyan') > -1) {
        body.classList.remove('xielunyan');
        this.xielunyanStatus = false;
      } else {
        body.classList.add('xielunyan');
        this.xielunyanStatus = true;
      }
    },
    initBox: function initBox() {
      var _this2 = this;

      this.$nextTick(function () {
        var xielunyan = _this2.$refs['xielunyan'];
        if (xielunyan) {
          _this2.winWidth = window.innerWidth;
          _this2.winHeight = window.innerHeight;
          xielunyan.style.right = 10 + 'px';
          xielunyan.style.top = '50%';
        }
      });
    }
  },
  computed: {
    isXieLunYan: function isXieLunYan() {
      return process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development';
    }
  }
};